import React from 'react';
import { connect } from 'react-redux';
import cn from "classnames";
import { withRouter } from 'react-router-dom';
import styles from '../../lib/global.css';
import Page from '../../components/page/page';
import bindAll from "lodash.bindall";

import { clazzAddCourse, deleteClazz, getClazz, saveClazz, getClazzMembers, clazzShare, disbandClazz } from '../../api/clazz';
import { getUser} from '../../api/user';
import { setClazz, setCourses, teachInitialState } from '../../reducers/teach';
import Card from "../../components/card/card";
import message from '../../components/message/message';
import BannerInfo from "../../components/banner-info/classs-banner";
import ButtonComponent from "../../../components/button/button";
import { showLoading } from "../../components/loading/loading";
import qs from "qs";
import Project from '../../components/project-list/project-transform'
import ModalManager from "../../components/modal/modal-manager";
import DisbandClass from '../../components/modal/exit-modal';
import ClazzFormModal from "../../components/clazz-form-modal/clazz-form-modal";
import CourseSelectModal from "../../components/course-select-modal/course-select-modal";
import { getNormalCourse } from "../../api/course";
import UserList from "../../components/user-list/user-list-tranform";
// import UserList from "../../components/user-list/user-list";
import StudentApplyModal from './student-apply-modal';
import InviteModal from "./invite-modal";
import style from './teacher-clazz.css';
import Pagination from 'rc-pagination';


/**
 * 课程详情页
 */
class TeacherClazzPage extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'getClazz',
            'saveClazz',
            'openEditClazzModal',
            'deleteCurrentClazz',
            'addCourse',
            'getClazzMembers',
            'handleStudentApply',
            'openInviteModal',
            'interceptCourse',
            'onPageChange',
            'getClazzShare',
            'sharePageChange',
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
        this.state = { showSelectCourse: false, classMembers: [], current: 1, pageSize: 9, listData: [], shareList: [], shareCurrent: 1, total: null,teacher:null };
        if (props.clazz.id != this.query.id) {
            props.setClazz(teachInitialState.clazz);
        }
    }

    componentDidMount() {
        this.getClazz();
        this.getClazzMembers();
        this.getClazzShare();
    }

    getClazz() {
        showLoading();
        getClazz({ id: this.query.id }, { quiet: !!this.props.clazz.id }).then(res => {
            this.props.setClazz(res);
        }).then(() => {
            this.interceptCourse();
            const {clazz} = this.props;
            getUser({ id: clazz.user_id }, { quiet: !!this.props.username }).then(res => {
                this.setState({
                    teacher:res.name
                })
            })
        });
    }

    async getClazzMembers() {
        const res = await getClazzMembers({ id: this.query.id, page_size: 100 });
        if (res && res.data) {
            this.setState({ classMembers: res.data });
        }
    }

    openInviteModal() {
        const { clazz } = this.props;
        ModalManager.open(InviteModal, {
            url: window.location.href.replace('/teacher/class', '/class'),
            clazzCode: clazz.code,
            clazzCourseId: clazz.id,
            // access: course.clazz_course.access,
            onClose: () => { },
        });
    }

    saveClazz(clazz) {
        saveClazz(clazz).then(res => {
            message.show(window.L("teach.class.saveSuccess"));
        });
    }

    openEditClazzModal() {
        const { clazz } = this.props;
        ModalManager.open(ClazzFormModal, {
            id: clazz.id,
            title: '编辑班级',
            name: clazz.name,
            schoolName: clazz.school_name,
            desc:clazz.desc,
            onClose: () => { },
            onSubmit: () => { this.getClazz() }
        });
    }

    //解散班级
    async deleteCurrentClazz() {
        // if (confirm(window.L("teach.class.deleteConfirm"))) {
        //     deleteClazz({ id: this.props.clazz.id }).then(() => {
        //         message.show(window.L("teach.common.deleteSuccess"));
        //         this.props.history.go(-1);
        //     })
        // }
        ModalManager.open(DisbandClass, {
            onClose: () => { },
            onSubmit: async () => {
                const res = await disbandClazz({ id: this.query.id })
                if (res) {
                    message.show(window.L("teach.common.deleteSuccess"));
                    this.props.history.go(-1);
                }
            },
            title: '解散班级',
            type: 'teacher'
        })
    }

    //添加课程
    addCourse(course) {
        clazzAddCourse({
            id: this.props.clazz.id,
            course_id: course.extensionId
        }).then(res => {
            message.show(res)
            this.getClazz();
        });
    }

    handleStudentApply() {
        ModalManager.open(StudentApplyModal, {
            onClose: () => { },
            title: '申请列表'
        })
    }

    //获取分享作品
    getClazzShare() {
        const { shareCurrent, pageSize } = this.state
        clazzShare({ clazz_id: this.query.id, page_size: pageSize, page: shareCurrent }, { quiet: !!this.props.clazz.id }).then(res => {
            this.setState({
                shareList: res.data,
                total: res.total
            })
        })
    }

    // 分享作品分页
    sharePageChange(page) {
        this.setState({
            shareCurrent: page
        }, () => {
            this.getClazzShare()
        })
    }

    // 分页截取课程
    interceptCourse() {
        const { clazz } = this.props;
        const { current, pageSize } = this.state;
        if (clazz && clazz.courses.length > 0) {
            this.setState({
                listData: clazz.courses.slice((current - 1) * pageSize, (current * pageSize))
            })
        }else{
            this.setState({
                listData: []
            })
        }
    }

    //分页
    onPageChange(page) {
        this.setState({
            current: page
        }, () => {
            this.interceptCourse()
        })
    };

    render() {
        if (this.props.clazz.id != this.query.id) {
            return null;
        }
        const { clazz } = this.props;
        const { pageSize, current, listData, shareList, total, shareCurrent,teacher } = this.state;
        // const noticeStyle = {
        //     width: "12px",
        //     height: "12px",
        //     position: "absolute",
        //     borderRadius: "50%",
        //     border: "2px solid #e6effb",
        //     top: -10,
        //     right: -17,
        //     backgroundColor: "red"
        // }
        return (
            <Page isModal={true} title={clazz.name}>
                {this.state.showSelectCourse &&
                    <CourseSelectModal
                        courses={this.props.courses.data}
                        onItemSelected={this.addCourse}
                        onRequestClose={() => {
                            this.setState({ ...this.state, showSelectCourse: false });
                        }}
                    />
                }
                {clazz.id ? (
                    <React.Fragment>
                        <BannerInfo
                            classInfo={clazz}
                            teacher={teacher}
                            // title={clazz.name}
                            // cover={clazz.cover || `${window.config.staticURL}/cover/class/default.png`}
                            // desc={clazz.school_name + ' ' + window.L('teach.clazz.code') + "：" + clazz.code}
                            type='teacher'
                            buttons={
                                <React.Fragment>
                                    <ButtonComponent
                                        className={styles.button}
                                        onClick={() => this.openEditClazzModal()}
                                    >编辑资料</ButtonComponent>
                                    {/* <ButtonComponent
                                            onClick={() => this.handleStudentApply()}
                                            className={styles.button}
                                            style={{marginLeft: "1rem"}}
                                        >
                                            <div style={{position: "relative"}}>
                                                <i style={noticeStyle}></i>
                                                <span>申请列表</span>
                                            </div>
                                        </ButtonComponent> */}
                                    <ButtonComponent
                                        className={styles.button}
                                        style={{ marginLeft: "1rem" }}
                                        disabled={!clazz.id}
                                        onClick={this.openInviteModal}
                                    >
                                        {window.L("teach.course.inviteToJoin")}
                                    </ButtonComponent>
                                </React.Fragment>
                            }
                            onExit={() => this.deleteCurrentClazz()}
                        />
                        <div className={style.classContent}>
                            <div>
                                <Card
                                    title={window.L('teach.class.courses')}
                                    buttons={
                                        <ButtonComponent
                                            className={styles.button}
                                            onClick={() => {
                                                this.setState({ ...this.state, showSelectCourse: true });
                                                getNormalCourse({ page_size: 100 }).then(res => this.props.setCourses(res));
                                            }}
                                        >
                                            添加
                                        </ButtonComponent>
                                    }
                                    style="white"
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <Project
                                            data={listData}
                                            itemNum={4}
                                            top={true}
                                            allowDelete={true}
                                            cardType='courseEdit'
                                            onClose={this.getClazz}
                                        />
                                        <Pagination
                                            current={current}
                                            defaultPageSize={pageSize}
                                            total={clazz.courses.length}
                                            onChange={this.onPageChange}
                                        ></Pagination>
                                    </div>
                                </Card>
                                <Card
                                    title={window.L('teach.class.shareProject')}
                                    style='white'
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <Project
                                            data={shareList}
                                            itemNum={4}
                                            userShow={true}
                                            share={true}
                                            allowDelete={true}
                                            onClose={this.getClazzShare}
                                        />
                                        <Pagination
                                            current={shareCurrent}
                                            defaultPageSize={pageSize}
                                            total={total}
                                            onChange={this.sharePageChange}
                                        ></Pagination>
                                    </div>
                                </Card>
                            </div>
                            <div>
                                <UserList
                                    title={window.L('teach.class.members')}
                                    users={this.state.classMembers}
                                    onItemSelected={() => { }}
                                    identity="teacher"
                                    onRemove={()=> this.getClazzMembers()}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                ) : null}
            </Page>
        );
    }

}


const mapStateToProps = state => ({
    clazz: state.teach.clazz,
    courses: state.teach.courses,
});


const mapDispatchToProps = dispatch => ({
    setClazz: res => dispatch(setClazz(res)),
    setCourses: courses => dispatch(setCourses(courses)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(TeacherClazzPage));
